import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.449 4.269A10.21 10.21 0 0 0 11.999 1a10.21 10.21 0 0 0-7.416 3.284 10.4 10.4 0 0 0-2.797 7.771.795.795 0 0 0 1.571.244 1.776 1.776 0 0 1 3.269 0 .786.786 0 0 0 1.445 0 1.76 1.76 0 0 1 3.143-.095v8.439a2.357 2.357 0 1 0 4.714 0v-.786a.785.785 0 0 0-1.571 0v.786a.785.785 0 1 1-1.571 0v-8.439a1.75 1.75 0 0 1 1.571-.99 1.77 1.77 0 0 1 1.634 1.085.786.786 0 0 0 1.446 0 1.776 1.776 0 0 1 3.269 0 .79.79 0 0 0 .723.487h.125a.786.786 0 0 0 .66-.723 10.39 10.39 0 0 0-2.765-7.794m-.378 5.374a3.33 3.33 0 0 0-2.357.974 3.34 3.34 0 0 0-4.714 0 3.34 3.34 0 0 0-4.714 0 3.33 3.33 0 0 0-2.358-.974c-.514 0-1.022.119-1.485.346a8.86 8.86 0 0 1 2.271-4.636A8.64 8.64 0 0 1 12 2.57a8.64 8.64 0 0 1 6.286 2.766 8.9 8.9 0 0 1 2.278 4.652 3.4 3.4 0 0 0-1.493-.346"
    }, null, -1)
  ]))]))
}
export default { render: render }